import { render } from "./PMR.vue?vue&type=template&id=39e88ed7&scoped=true"
import script from "./PMR.vue?vue&type=script&lang=js"
export * from "./PMR.vue?vue&type=script&lang=js"

import "./PMR.vue?vue&type=style&index=0&id=39e88ed7&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e88ed7"]])

export default __exports__